import type { PortalState, Report, ReportManualDeliveryRecord, ReportPdfExportRecord, ReportVersion } from "./domain";
import { resolveReportPdfExportEligibility } from "./report-pdf-export";
import { hasCurrentPreDeliveryBackup } from "./workspace-backup";

const practicalEmail=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export interface ReportManualDeliveryEligibility {
  eligible:boolean;
  blockers:string[];
  clientContentSignature:string;
  preparedRecords:ReportPdfExportRecord[];
}

/** Resolves the delivery gate without changing the established print/export gate. */
export function resolveReportManualDeliveryEligibility(state:PortalState,report:Report,version:ReportVersion):ReportManualDeliveryEligibility {
  const print=resolveReportPdfExportEligibility(state,report,version);
  const preparedRecords=(state.reportPdfExports??[]).filter(record=>
    record.organisationId===report.organisationId &&
    record.reportId===report.id &&
    record.reportVersionId===version.id &&
    record.clientContentSignature===print.clientContentSignature &&
    record.method==="Browser PDF",
  );
  const blockers=[...print.blockers];
  if(!report.auditEngagementId) blockers.push("This report is not linked to an audit delivery record.");
  if(!preparedRecords.length) blockers.push("Record PDF prepared for this exact approved report version before recording delivery.");
  if(!hasCurrentPreDeliveryBackup(state,report)) blockers.push("Prepare a current workspace backup before recording delivery.");
  return {eligible:blockers.length===0,blockers:[...new Set(blockers)],clientContentSignature:print.clientContentSignature,preparedRecords};
}

export function manualDeliveryValidation(record:ReportManualDeliveryRecord):string[] {
  const errors:string[]=[];
  if(!record.recipientName.trim()) errors.push("Enter the recipient name.");
  if(!record.recipientEmail.trim()) errors.push("Enter the recipient email address.");
  else if(!practicalEmail.test(record.recipientEmail.trim())) errors.push("Enter a valid recipient email address.");
  if(!record.sentAt || Number.isNaN(Date.parse(record.sentAt))) errors.push("Enter the date and time sent.");
  if(!record.filename.trim()) errors.push("Choose the prepared PDF being delivered.");
  return errors;
}

export function isExactManualDeliveryDuplicate(records:ReportManualDeliveryRecord[],candidate:ReportManualDeliveryRecord) {
  return records.some(record=>
    record.reportVersionId===candidate.reportVersionId &&
    record.pdfPreparedRecordId===candidate.pdfPreparedRecordId &&
    record.filename===candidate.filename &&
    record.recipientEmail.trim().toLowerCase()===candidate.recipientEmail.trim().toLowerCase() &&
    record.recipientName.trim()===candidate.recipientName.trim() &&
    record.sentAt===candidate.sentAt,
  );
}
